import { DebugLog } from './DebugLog.js';

/**
 * Handles keyboard + mouse input, provides clean state queries.
 */
export class InputManager {
  constructor(canvas, eventBus) {
    this.canvas = canvas;
    this.eventBus = eventBus;

    // Keyboard state
    this.keys = {};
    this.keysJustPressed = {};
    this.keysJustReleased = {};

    // Mouse state
    this.mouse = { x: 0, y: 0, down: false, justPressed: false, justReleased: false };

    // Bind handlers
    this._onKeyDown = this._onKeyDown.bind(this);
    this._onKeyUp = this._onKeyUp.bind(this);
    this._onMouseMove = this._onMouseMove.bind(this);
    this._onMouseDown = this._onMouseDown.bind(this);
    this._onMouseUp = this._onMouseUp.bind(this);

    window.addEventListener('keydown', this._onKeyDown);
    window.addEventListener('keyup', this._onKeyUp);
    canvas.addEventListener('mousemove', this._onMouseMove);
    canvas.addEventListener('mousedown', this._onMouseDown);
    canvas.addEventListener('mouseup', this._onMouseUp);
    canvas.addEventListener('contextmenu', e => e.preventDefault());

    DebugLog.info('InputManager', 'Initialized');
  }

  _onKeyDown(e) {
    if (!this.keys[e.code]) {
      this.keysJustPressed[e.code] = true;
    }
    this.keys[e.code] = true;
  }

  _onKeyUp(e) {
    this.keys[e.code] = false;
    this.keysJustReleased[e.code] = true;
  }

  _onMouseMove(e) {
    const rect = this.canvas.getBoundingClientRect();
    const scaleX = this.canvas.width / rect.width;
    const scaleY = this.canvas.height / rect.height;
    this.mouse.x = (e.clientX - rect.left) * scaleX;
    this.mouse.y = (e.clientY - rect.top) * scaleY;
  }

  _onMouseDown(e) {
    this.mouse.down = true;
    this.mouse.justPressed = true;
    this.mouse.button = e.button;
  }

  _onMouseUp(e) {
    this.mouse.down = false;
    this.mouse.justReleased = true;
  }

  isKeyDown(code) {
    return !!this.keys[code];
  }

  isKeyJustPressed(code) {
    return !!this.keysJustPressed[code];
  }

  // Movement helpers
  get moveX() {
    let x = 0;
    if (this.keys['KeyA'] || this.keys['ArrowLeft']) x -= 1;
    if (this.keys['KeyD'] || this.keys['ArrowRight']) x += 1;
    return x;
  }

  get moveY() {
    let y = 0;
    if (this.keys['KeyW'] || this.keys['ArrowUp']) y -= 1;
    if (this.keys['KeyS'] || this.keys['ArrowDown']) y += 1;
    return y;
  }

  update() {
    this.keysJustPressed = {};
    this.keysJustReleased = {};
    this.mouse.justPressed = false;
    this.mouse.justReleased = false;
  }

  destroy() {
    window.removeEventListener('keydown', this._onKeyDown);
    window.removeEventListener('keyup', this._onKeyUp);
    this.canvas.removeEventListener('mousemove', this._onMouseMove);
    this.canvas.removeEventListener('mousedown', this._onMouseDown);
    this.canvas.removeEventListener('mouseup', this._onMouseUp);
  }
}
